import "@/App.css";
import { LanguageProvider } from "@/i18n";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { About } from "@/components/landing/About";
import { Contact } from "@/components/landing/Contact";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-[#F8F9FA] antialiased" data-testid="landing-page">
        <Header />
        <main>
          <Hero />
          <Services />
          <About />
          <Contact />
        </main>
      </div>
    </LanguageProvider>
  );
}

export default App;
